<template>
  <div class="app-container">
    <PurchaseViewForm is-edit />
  </div>
</template>
<script>
import PurchaseViewForm from '@/views/center-business/purchase/order/components/CsgPurchaseViewForm.vue';
export default {
  name: 'BusinessPurchaseOrderCsgAdminEdit',
  components: { PurchaseViewForm },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  mounted() {
  },
  methods: {},
};
</script>
